document.addEventListener('DOMContentLoaded',()=>{
    // Mise a jour des liens active en fonction du scroll
    const sections = document.querySelectorAll('section');
    const navLinks = document.querySelectorAll('.nav-link');
    const navLinksResponsive = document.querySelectorAll('.nav-link.responsive');

    // Fonction pour mettre à jour la classe active
    function updateActiveLink() {
        let index = sections.length;

        // Parcourir les sections pour laquelle est dans la vue
        while (--index && window.scrollY + 100  < sections[index].offsetTop) {}

        // Retirer la classe active de tous les liens
        navLinks.forEach(link => link.classList.remove('active'));
        navLinksResponsive.forEach(link => link.classList.remove('active'))

        // Ajouter la classe active au lieu correspondant
        navLinks[index].classList.add('active');
        navLinksResponsive[index].classList.add('active');
    }
    window.addEventListener('scroll',updateActiveLink);

    // Animation de scroll vers le lien selectionné
    document.querySelectorAll('.nav-link').forEach(link => {
        link.addEventListener('click', function(e){
            e.preventDefault();//Empeche le comportement par defaut du lien

            // Récupère la section  cible à partir de l'attribut href
            const targetId = this.getAttribute('href').substring(1);
            const targetSection = document.getElementById(targetId);

            // Faire defiler la page jusqu'a la section cible
            targetSection.scrollIntoView({
                behavior : 'smooth',
                block : 'start'
            });
        })
    });
    // responsive
    document.querySelectorAll('.nav-link.responsive').forEach(link => {
        link.addEventListener('click', function(e){
            e.preventDefault();//Empeche le comportement par defaut du lien

            // Récupère la section  cible à partir de l'attribut href
            const targetId = this.getAttribute('href').substring(1);
            const targetSection = document.getElementById(targetId);

            // Faire defiler la page jusqu'a la section cible
            targetSection.scrollIntoView({
                behavior : 'smooth',
                block : 'start'
            });
        })
    });
});